"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPerformanceScpiFonctionCorporationTrads = void 0;
exports.ESubPerformanceScpiFonctionCorporationTrads = {
    desDeux: "Des deux",
    dividendeDistribue: "Du dividende distribué",
    evolutionPrixPart: "De l'évolution du prix de la part",
};
